// extracted by mini-css-extract-plugin
module.exports = {"check":"check-cross_check__2qalq","cross":"check-cross_cross__Q0mZy"};